import { render, staticRenderFns } from "./DashboardStudyList.vue?vue&type=template&id=3eebd790&"
import script from "./DashboardStudyList.vue?vue&type=script&lang=js&"
export * from "./DashboardStudyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports